"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactIntl = require("react-intl");
var _PaymentContext = _interopRequireDefault(require("../../context/PaymentContext"));
var _AmountSelection = _interopRequireDefault(require("../AmountSelection/AmountSelection"));
var _ = require("./..");
var _browser = require("../../browser");
var _components = require("../../components");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Payment = function (_PureComponent) {
  function Payment() {
    var _this;
    (0, _classCallCheck2["default"])(this, Payment);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
    return _this = _callSuper(this, Payment, [].concat(args)), (0, _defineProperty2["default"])(_this, "state", {
      selectedProvider: _this.initialProvider
    }), (_this = _callSuper(this, Payment, [].concat(args)), (0, _defineProperty2["default"])(_this, "state", {
      selectedProvider: _this.initialProvider
    }), _this);
  }
  return (0, _inherits2["default"])(Payment, _PureComponent), (0, _createClass2["default"])(Payment, [{
    key: "handleClick",
    value: function handleClick(provider) {
      var selectedProvider = this.props.providers.find(function (p) {
        return p.name === provider;
      });
      this.setState({
        selectedProvider: selectedProvider
      });
    }
  }, {
    key: "initialProvider",
    get: function get() {
      var _this$props = this.props,
        providers = _this$props.providers,
        preferredProvider = _this$props.preferredProvider;
      return providers.length === 1 ? providers[0] : providers.find(function (p) {
        return p.name === preferredProvider;
      });
    }
  }, {
    key: "onBack",
    get: function get() {
      var _this2 = this;
      var _this$props2 = this.props,
        amount = _this$props2.amount,
        setAmount = _this$props2.setAmount,
        providers = _this$props2.providers,
        paymentOptions = _this$props2.paymentOptions,
        clearWarning = _this$props2.clearWarning;
      var selectedProvider = this.state.selectedProvider;
      return providers.length > 1 && selectedProvider ? function () {
        return _this2.setState({
          selectedProvider: null
        });
      } : paymentOptions.length > 0 && amount ? function () {
        setAmount(), clearWarning();
      } : undefined;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props3 = this.props,
        captured = _this$props3.captured,
        providers = _this$props3.providers,
        paymentOptions = _this$props3.paymentOptions,
        amount = _this$props3.amount,
        warning = _this$props3.warning,
        notification = _this$props3.notification,
        onError = _this$props3.onError,
        clearWarning = _this$props3.clearWarning,
        clearNotification = _this$props3.clearNotification;
      var selectedProvider = this.state.selectedProvider;
      if (captured) return _react["default"].createElement(_browser.Container, null, _react["default"].createElement(_browser.Title, null, _react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "htmPayment.completed.header"
      })));
      var hasGoToNotification = notification === null || notification === void 0 ? void 0 : notification.goToCampaign;
      if (hasGoToNotification) return _react["default"].createElement(_components.GoToCampaignNotification, {
        onContinue: function onContinue() {
          return clearNotification();
        }
      });
      if (!amount && paymentOptions.length === 0) {
        var error = {
          message: 'Missing props, no amount or payment options passed',
          code: 'htmPayment.amount.validation_error.missingProps'
        };
        return onError(error), null;
      }
      return providers.length === 0 ? _react["default"].createElement(_browser.Container, null, _react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "htmPayment.selector.noProvider"
      })) : paymentOptions.length > 0 && !amount ? _react["default"].createElement(_AmountSelection["default"], null) : warning.isLowAmount || warning.isHighAmount ? _react["default"].createElement(_components.Warning, {
        onBack: this.onBack,
        onContinue: clearWarning,
        warning: warning
      }) : selectedProvider ? _react["default"].createElement(_.ProviderSelected, {
        provider: selectedProvider,
        onBack: this.onBack
      }) : amount && providers.length > 1 ? _react["default"].createElement(_.ProviderSelection, {
        amount: amount,
        onClick: function onClick(provider) {
          return _this3.handleClick(provider);
        },
        onBack: this.onBack
      }) : null;
    }
  }]);
}(_react.PureComponent);
var PaymentWithContext = function PaymentWithContext(props) {
  var _context$callbacks, _context$paymentStore, _context$paymentStore2, _context$paymentStore3, _context$actions, _context$actions2, _context$actions3, _context$paymentStore4;
  var context = (0, _react.useContext)(_PaymentContext["default"]);
  return _react["default"].createElement(Payment, (0, _extends2["default"])({
    providers: context === null || context === void 0 ? void 0 : context.providers,
    onError: context === null || context === void 0 || (_context$callbacks = context.callbacks) === null || _context$callbacks === void 0 ? void 0 : _context$callbacks.onError,
    amount: context === null || context === void 0 || (_context$paymentStore = context.paymentStore) === null || _context$paymentStore === void 0 ? void 0 : _context$paymentStore.amount,
    warning: context === null || context === void 0 || (_context$paymentStore2 = context.paymentStore) === null || _context$paymentStore2 === void 0 ? void 0 : _context$paymentStore2.warning,
    notification: context === null || context === void 0 || (_context$paymentStore3 = context.paymentStore) === null || _context$paymentStore3 === void 0 ? void 0 : _context$paymentStore3.notification,
    clearWarning: context === null || context === void 0 || (_context$actions = context.actions) === null || _context$actions === void 0 ? void 0 : _context$actions.clearWarning,
    clearNotification: context === null || context === void 0 || (_context$actions2 = context.actions) === null || _context$actions2 === void 0 ? void 0 : _context$actions2.clearNotification,
    setAmount: context === null || context === void 0 || (_context$actions3 = context.actions) === null || _context$actions3 === void 0 ? void 0 : _context$actions3.setAmount,
    paymentOptions: context === null || context === void 0 ? void 0 : context.paymentOptions,
    captured: context === null || context === void 0 || (_context$paymentStore4 = context.paymentStore) === null || _context$paymentStore4 === void 0 ? void 0 : _context$paymentStore4.captured,
    preferredProvider: context === null || context === void 0 ? void 0 : context.preferredProvider
  }, props));
};
var _default = exports["default"] = PaymentWithContext;